<mat-calendar (selectedChange)="_onSelectedChange($event)"
              [selected]="selectedDateRange">
</mat-calendar>

<button (click)="closeDialog()">cdd</button>
